exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".engagement-intro{width:100%;position:relative}.engagement-intro .section-intro .title{max-width:1000px;margin:auto}.engagement-intro .story-wrapper{position:relative;z-index:50;text-align:center;margin-top:100px}.engagement-intro .story-wrapper .story-text{margin:auto;max-width:580px}.engagement-intro .story-wrapper .quote{margin:auto;max-width:830px}.engagement-intro .story-wrapper .quote-1,.engagement-intro .story-wrapper .quote-2,.engagement-intro .story-wrapper .text-3{margin-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77aed091","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/sections/engagement/_components/engagement-intro.vue
// module id = 603
// module chunks = 0